export default{
    users: {},
    loading: false,
    error: "",
    user_contact: {},
    user_additional_contact: {},
    user: null
}